export const login = {
  email: "jasmine@email.com",
  password: "••••••••••••",
  remember: false
}

export const register = {
  email: "jasmine@email.com",
  mobile: "+65 93837474",
  password: "••••••••••••"
}

export const registerTeam = {
  name: "Vita Verify",
  email: "jasmine@vitaverify.me",
  password: "••••••••••••"
}

export const autofill = {
  link: "linkedin.com/in/jasmine"
}

export const reset = {
  email: "jasmine@email.com",
  token: "123456",
  password: "••••••••••••",
}

export const profile = {
  name: "Full Name",
  headline: "Software Engineer",
  summary: "Passionate engineer with background in maritime who loves problem solving"
}

export const members = {
  name: "Full Name",
  email: "email@company.com",
  role: "Marketing",
  linkedin: "https://linkedin.com/in/james",
}

export const experiences = {
  title: "Full Name",
  employmentType: "Full-time",
  company: "Company",
  location: "Singapore",
  description: "Work description here"
}

export const educations = {
  institution: 'National University of Singapore',
  title: 'BSc. Computer Science - Majoring in Cybersecurity',
  description: 'Elaborate on significant achievement and co-curriculum activities here'
}

export const references = {
  name: 'Referee name',
  email: 'To verify identity, references from professional emails are prioritised',
  contactDetails: 'Companies may need to contact referee to verify their identity',
  company: 'Referee company',
  position: 'Referee position'
}

export const listings = {
  title: 'Software Engineer',
  description: 'Job description'
}

export const alias = {
  alias: 'google-devops'
}

export const assessmentVerify = {
  email: 'kotaro@vitaverify.me',
  company: 'Deloitte',
  position: 'Account Manager'
}

export const refereeRecommend = {
  email: 'amazing@talent.com'
}
